import * as Types from '../constants/Types';
import { PAGINATION } from '../constants/Define';
import { findIndex } from 'lodash';
import Agent from './../models/Agent';

const initialState = {
    isFetching: false,
    isFetched: false,
    agents: [],
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    loadingGroup: false,
    detail: {
        agent: new Agent()
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.AGENT_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.AGENT_LIST_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                agents: action.agents.result,
                pageSize: action.agents.pageSize,
                pageIndex: action.agents.pageIndex,
                totalCount: action.agents.totalCount,
                totalPage: Math.ceil(parseInt(action.totalCount) / parseInt(action.pageSize))
            };
        case Types.AGENT_LIST_FAIL:
            return { ...state, isFetching: false, isFetched: true, agents: [] };
        case Types.AGENT_DETAIL_ACTION:
            return { ...state, isFetching: true, detail: initialState.detail };
        case Types.AGENT_DETAIL_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                detail: {
                    agent: action.agent
                }
            };
        case Types.AGENT_DETAIL_FAIL:
            return { ...state, isFetching: false, isFetched: true };
        case Types.SITEINFO_DETAIL_CREATE_ACTION:
            return { ...state, isFetching: true };
        case Types.SITEINFO_DETAIL_UPDATE_ACTION:
            return { ...state, isFetching: true };
        case Types.AGENT_DETAIL_DELETE_ACTION:
            return { ...state, isFetching: true };
        case Types.AGENT_LIST_REPORTS_ACTION:
            return {...state, loadingGroup: true}
        case Types.AGENT_LIST_REPORTS_SUCCESS:
            const agents = state.agents;
            const detailIndex = findIndex(agents, item => item.id === action.params.agentId);
            if (detailIndex >= 0) agents[detailIndex].setDetail({ ...action.params, items: action.reports });
            return {
                ...state,
                isFetching: false,
                loadingGroup: false,
                agents
            };
        default: return state
    }
}